import BulkUploadError from "./BulkUploadError";
export default BulkUploadError;
